if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector("input[name=\"locale_code\"], input[name=\"country_code\"]"),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      const item = event.currentTarget;
      this.elements.input.value = item.dataset.value;
      const picker = this.querySelector('[data-bvm-language-picker]');
      if (picker && form) {
        const setField = (name, value) => {
          let field = form.querySelector('input[name="' + name + '"]');
          if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.appendChild(field); }
          field.value = value;
        };
        let country = item.dataset.marketCountry;
        if (country) {
          try {
            if (country === 'BR' && picker.dataset.country !== 'BR') sessionStorage.setItem('bvm-country-before-br', picker.dataset.country);
            if (item.dataset.restoreCountry) {
              const previous = sessionStorage.getItem('bvm-country-before-br');
              if (previous && /^[A-Z]{2}$/.test(previous) && previous !== 'BR') country = previous;
            }
          } catch (_) { /* Country selection also works when storage is unavailable. */ }
          setField('country_code', country);
        }
        if (item.dataset.returnTo && item.dataset.returnTo.startsWith('/')) {
          // Shopify's localization endpoint requires an encoded return path.
          // URL keeps existing escapes intact and encodes Japanese characters.
          const target = new URL(item.dataset.returnTo, window.location.origin);
          if (target.origin === window.location.origin) {
            setField('return_to', target.pathname + target.search + target.hash);
          }
        }
      }
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const isChild = this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
      if (!event.relatedTarget || !isChild) {
        this.hidePanel();
      }
    }
  });
}
